import { createSlice } from "@reduxjs/toolkit";
import { act } from "react-dom/test-utils";

export const SALARY_SLICE = "salary"
const salarySlice = createSlice({
    name: SALARY_SLICE,
    initialState: {
        isLoading: false,
        isLogin: false,
        commonTypeByGroupType: [],
        commonTypeCompany: [],
        salaryDecryptInformation: [],
        allowancesType: {},
        currentAllowances: {},
        employmentTypeOptions: [],
        movementByTypePayment: [],
        incomeDeduction: {},
        incomeDeductionSetup: {},
        payrollPeriodOption: [],
        employeePaymentMethod: {},
        employeePayrollByPeriod: {},
        totalNetIncome: 0,
        paySlipData: {},
        stepTaxData: {},
        allowancesData: {},
        auditLogIncomeAndDuections: [],
        payrollPeriodYear: [],
        payrollPeriodByEmployee: {},
        employeeYearAccumulate: [],
        employeeOvertimeList: []
    },
    reducers: {
        setIsLoading(state, action) {
            state.isLoading = action.payload;
        },
        setCommonTypeByGroupType(state, action) {
            state.commonTypeByGroupType = action.payload;
        },
        setCommonTypeCompany(state, action) {
            state.commonTypeCompany = action.payload;
        },
        setSalaryDecryptInformation(state, action) {
            state.salaryDecryptInformation = action.payload
        },
        setAllowancesType(state, action) {
            state.allowancesType = action.payload;
        },
        setCurrentAllowances(state, action) {
            state.currentAllowances = action.payload;
        },
        setEmploymentTypeOptions(state, action) {
            state.employmentTypeOptions = action.payload;
        },
        setMovementByTypePayment(state, action) {
            state.movementByTypePayment = action.payload;
        },
        setIncomeDeduction(state, action) {
            state.incomeDeduction = action.payload;
        },
        setIncomeDeductionSetup(state, action) {
            state.incomeDeductionSetup = action.payload;
        },
        setPayrollPeriodOption(state, action) {
            state.payrollPeriodOption = action.payload;
        },
        setEmployeePaymentMethod(state, action) {
            state.employeePaymentMethod = action.payload;
        },
        setEmployeePayrollByPeriod(state, action) {
            state.employeePayrollByPeriod = action.payload;
        },
        setTotalNetIncome(state, action) {
            state.totalNetIncome = action.payload;
        },
        setPaySlipData(state, action) {
            state.paySlipData = action.payload;
        },
        setStepTaxData(state, action) {
            state.stepTaxData = action.payload;
        },
        setAllowancesData(state, action) {
            state.allowancesData = action.payload;
        },
        setAuditLogIncomeAndDuections(state, action) {
            state.auditLogIncomeAndDuections = action.payload;
        },
        setPayrollPeriodYear(state, action) {
            state.payrollPeriodYear = action.payload;
        },
        setPayrollPeriodByEmployee(state, action) {
            state.payrollPeriodByEmployee = action.payload;
        },
        setEmployeeYearAccumulate(state, action) {
            state.employeeYearAccumulate = action.payload;
        },
        setEmployeeOvertimeList(state, action) {
            state.employeeOvertimeList = action.payload;
        }
    },
});

export const {
    setIsLoading,
    setCommonTypeByGroupType,
    setCommonTypeCompany,
    setSalaryDecryptInformation,
    setAllowancesType,
    setCurrentAllowances,
    setEmploymentTypeOptions,
    setMovementByTypePayment,
    setIncomeDeduction,
    setIncomeDeductionSetup,
    setPayrollPeriodOption,
    setEmployeePaymentMethod,
    setEmployeePayrollByPeriod,
    setTotalNetIncome,
    setPaySlipData,
    setStepTaxData,
    setAllowancesData,
    setAuditLogIncomeAndDuections,
    setPayrollPeriodYear,
    setPayrollPeriodByEmployee,
    setEmployeeYearAccumulate,
    setEmployeeOvertimeList
} = salarySlice.actions;
export default salarySlice.reducer;